import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { twMerge } from "tailwind-merge";
import { getButtonClassNames } from "./helpers/getButtonClassNames";
import LoadingButtonLine from "./components/LoadingButtonLine";
/**
 * Main BLAST.tv button.
 *
 * @param children - Content to be displayed within the button.
 * @param variant - Style variant of the button. Defaults to "default".
 * @param isDisabled - Determines if the button should be disabled.
 * @param isLoading - Determines if the button is in a loading state.
 * @param type - HTML button type attribute. Defaults to "button".
 * @param onClick - Click handler function for the button.
 * @param className - Additional classes to be applied to the button.
 * @returns JSX.Element - Rendered button element.
 *
 * @example
 *
 * ```jsx
 * <Button variant="secondary" onClick={closeModal}>
 *   Cancel
 * </Button>
 * ```
 *
 */
export function Button({ children, variant = "default", isDisabled, isLoading, type = "button", onClick, className, }) {
    const attributes = {
        disabled: isDisabled || isLoading,
    };
    if (variant === "success") {
        attributes.disabled = true;
    }
    return (_jsx("button", Object.assign({}, attributes, { className: twMerge(classnames("m-0 flex h-fit touch-manipulation select-none flex-col place-items-center justify-center rounded-small border border-solid transition-all duration-100 ease-in-out", getButtonClassNames(variant, attributes.disabled), {
            "hover:cursor-pointer": !attributes.disabled,
            "px-7 py-3": variant !== "tertiary",
            "p-0": variant === "tertiary",
        }), className), onClick: attributes.disabled ? undefined : onClick, type: type, children: isLoading ? (_jsxs("div", { className: "relative h-4 place-content-center place-items-center", children: [_jsx("div", { className: "flex h-full place-content-center items-center", children: _jsx(LoadingButtonLine, {}) }), _jsx("div", { className: "invisible h-0 w-fit", children: _jsx("span", { className: "text-inherit opacity-0 font-style-label-3", children: children }) })] })) : (_jsx("span", { className: "text-inherit font-style-label-3", children: children })) })));
}
//# sourceMappingURL=Button.js.map